import { $ } from "./imports";

/*==================== LIGHTBOX2 ====================*/
const popupGallery = () => {
    // Para galeria detalle de blog/noticias
    if($('.blog-detail__gallery').length > 0){
        lightbox.option({
            alwaysShowNavOnTouchDevices: true, //mostrar navegacion siempre
            wrapAround: true, // loop, volver a la primera imagen
            disableScrolling: true, // deshabilita scroll pagina
            albumLabel: "Imagen %1 de %2",
        });
    }
}

export default popupGallery;